import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.frameNotes || initialState;

export const selectFrameNotes = createSelector([selectSlice], state => state);
export const selectFrameNotesReport = createSelector(
  [selectSlice],
  state => state.note,
);
